/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationEqual extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationEqual");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationEqual.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationEqual>): BillingRuleAllocationEqual {
        let obj = Object.assign(new BillingRuleAllocationEqual(), model);
        BillingRuleAllocationEqual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationEqual>): BillingRuleAllocationEqual {
        if (!model) return null;
        return BillingRuleAllocationEqual.newInstance(<BillingRuleAllocationEqual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationEqual) {
        if (!obj) return;

        models.BillingRuleAllocationEqual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationEqual): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationEqual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
